import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Refresh interceptor: on 401, try /auth/refresh once, then retry the request.
let refreshInFlight = null;

api.interceptors.response.use(
    (r) => r,
    async (error) => {
        const original = error.config;
        const status = error.response?.status;
        if (!original || original.__retried) throw error;
        // don't try to refresh a failed refresh, login or /me pre-auth check
        if (
            status === 401 &&
            !original.url?.includes("/auth/refresh") &&
            !original.url?.includes("/auth/login")
        ) {
            try {
                if (!refreshInFlight) {
                    refreshInFlight = api.post("/auth/refresh").finally(() => {
                        refreshInFlight = null;
                    });
                }
                await refreshInFlight;
                original.__retried = true;
                return api.request(original);
            } catch (e) {
                throw error;
            }
        }
        throw error;
    },
);

export function apiErr(e, fallback = "Something went wrong") {
    const detail = e?.response?.data?.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((d) => (typeof d === "string" ? d : d?.msg || JSON.stringify(d)))
            .join(" ");
    }
    if (detail && typeof detail.msg === "string") return detail.msg;
    return e?.message || fallback;
}
